import { render, staticRenderFns } from "./InfoColaborador.vue?vue&type=template&id=59d82849&scoped=true&"
import script from "./InfoColaborador.vue?vue&type=script&lang=js&"
export * from "./InfoColaborador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d82849",
  null
  
)

export default component.exports